import React from 'react'
import { BaseView, BaseText } from '@/components/base'
import { CardItem } from '@/components/CardItem'

interface RequestHeaderProps {
  avatar: {
    uri?: string
    name: string
    colors?: string[]
  }
  title: string
  userFullName: string
  amount: string
  fiatAmount?: string
}

export const RequestHeader: React.FC<RequestHeaderProps> = ({
  avatar,
  title,
  userFullName,
  amount,
  fiatAmount,
}) => {
  return (
    <BaseView gap={40} align="center" pt={60}>
      {/* Avatar */}
      <BaseView>
        {avatar.colors ? (
          <CardItem.AvatarGradient
            colors={avatar.colors}
            name={avatar.name}
            iconName="users"
            size={100}
            iconSize={40}
            start={[1, 0]}
            end={[0, 1]}
          />
        ) : (
          <CardItem.Avatar uri={avatar.uri} name={avatar.name} size={100} />
        )}
      </BaseView>

      {/* Request Info */}
      <BaseView gap={12} align="center">
        <BaseText
          fontSize={24}
          fontFamily="semibold"
          color="label.default"
          textAlign="center"
        >
          {title}
        </BaseText>

        <BaseView center gap={4}>
          <BaseText
            fontSize={32}
            fontFamily="bold"
            color="label.default"
            textAlign="center"
          >
            {amount}
          </BaseText>

          {fiatAmount && (
            <BaseText
              fontSize={16}
              fontFamily="regular"
              color="label.description"
              textAlign="center"
            >
              {fiatAmount}
            </BaseText>
          )}
        </BaseView>

        <BaseText
          fontSize={16}
          fontFamily="regular"
          color="label.description"
          textAlign="center"
        >
          {userFullName}
        </BaseText>
      </BaseView>
    </BaseView>
  )
}
